import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    connect() {
        this.carousel = null;
        this.ctner = this.element.querySelector('.swiper');
        let config = {
            slidesPerView: 1,
            spaceBetween: 8,
            speed: 800,
            scrollbar: {
                el: this.element.querySelector(".swiper-scrollbar"),
                draggable: true,
                hide: false,
            },
            observer: true,
            navigation : {
                nextEl : this.element.querySelector('[data-nav="right"]'),
                prevEl : this.element.querySelector('[data-nav="left"]')
            },
            breakpoints: {
                768: {
                    spaceBetween: 16,
                }
            }
        };
        this.initCarousel(config);
    }
    initCarousel(config) {
        import(/* webpackChunkName: "swiper" */ 'swiper').then(({Swiper}) => {
            import(/* webpackChunkName: "swiper-modules" */ 'swiper/modules').then(({Scrollbar, Navigation}) => {
                Swiper.use([Scrollbar, Navigation]);
                this.carousel = new Swiper(this.ctner, config);
            });
        });
    }
}